<div class="wallet-container container ">
    <!-- Header -->
    <h2 class="wallet-title">Phlenu Wallet</h2>
    <div class="wallet-balance-card">
        <div>
            <div class="balance-label">BALANCE</div>
            <div class="balance-amount">
                <ng-container *ngIf="!loading; else shimmerBalance">
                    {{this._auth.walletAmount | async}}
                    <span class="balance-currency">{{this.country == 'Ghana' ? 'GHS' : 'NGN'}}</span>
                </ng-container>
                <ng-template #shimmerBalance>
                    <div class="shimmer shimmer-balance"></div>
                </ng-template>
            </div>
        </div>
        <button class="add-fund-btn" (click)="onAddWalletFund()" [disabled]="loading">Add Fund</button>
    </div>

    <!-- Transactions -->
    <div class="wallet-history-list">
        <ng-container *ngIf="loading; else loadedTransactions">
            <!-- Shimmer for transaction list -->
            <div *ngFor="let i of [1,2,3]" class="wallet-history-card border border-gray-color">
                <div class="history-icon">
                    <div class="shimmer shimmer-icon"></div>
                </div>
                <div class="history-details">
                    <div class="shimmer shimmer-date"></div>
                    <div class="shimmer shimmer-ref"></div>
                    <div class="shimmer shimmer-remarks"></div>
                </div>
                <div class="history-amount">
                    <div class="shimmer shimmer-amount"></div>
                </div>
            </div>
        </ng-container>
        <ng-template #loadedTransactions>
            <ng-container *ngIf="this.walletData?.walletHistory?.length; else noTransactions">
                <ng-container *ngFor="let item of this.walletData?.walletHistory">
                    <div class="wallet-history-card border border-gray-color    ">
                        <div class="history-icon">
                            <img *ngIf="item.amount > 0" src="/assets/images/ui/arrow_downward.svg" alt="" />
                            <img *ngIf="item.amount < 0" src="/assets/images/ui/arrow_upward.svg" alt="" />
                        </div>

                        <div class="history-details">
                            <div class="history-date">{{item.createdDate | date:'dd MMM, h:mm a'}}</div>
                            <div class="history-ref text-blue-theme-color">
                                <span class="ref-label ">Ref. Id:</span>
                                <span class="ref-id">#{{item.referenceId}}</span>
                            </div>
                            <div class="history-remarks text-black-color">{{item?.remarks}}</div>
                        </div>
                        <div class="history-amount" [ngClass]="{'credit': item.amount > 0, 'debit': item.amount < 0}">
                            {{item.currency}} {{this.convert(item.amount)}}
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-template #noTransactions>
                <p class="no-transactions">No Transaction Yet!</p>
            </ng-template>
        </ng-template>
    </div>
</div>